import api from '@/utils/api'
import {Commit} from 'vuex'

const actions = {
  async queryFileOutRecordList(_context: { commit: Commit }, params: any) {
    return api.post('/api/fileOutRecord/queryFileOutRecordList', params)
  },
  async fileContentScan(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/file_scan', params, {
      timeout: 300 * 1000,
      params: {
        no_need_cancel: true
      }
    })
  },
  async matchingStrategy(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/matching_strategy', params)
  },
  async submitFileOutOrder(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/submitFileOutOrder', params)
  },
  async submitFileOutOrderExemption(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/submitFileOutOrderExemption', params)
  },
  async submitRenewFileOutOrder(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/submitRenewFileOutOrder', params)
  },
  async queryLastRecordInfo(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/queryLastRecordInfo', params)
  },
  async xmFileOutGoing(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/xmFileOutGoing', params, {
      timeout: 300 * 1000,
      params: {
        no_need_cancel: true
      }
    })
  },
  async queryApprovalDetails(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/queryApprovalDetails', params);
  },
  async queryFileInfoList(_context: { commit: Commit }, params: any) {
    return api.get('/api/distribute/fileOutgoing/query_file_info', {params: params})
  },
  async query_bpm_approval_chain(_context: { commit: Commit }, params: any) {
    return api.get('/api/distribute/fileOutgoing/query_bpm_approval_chain', {params: params})
  },
  // 他人的文件外发申请查看
  async querySubordinateFileOutRecordList(_context: { commit: Commit }, params: any) {
    return api.post('/api/applyCheck/querySubordinateFileOutRecordList', params)
  },
  async queryOtherFileOutRecordList(_context: { commit: Commit }, params: any) {
    return api.post('/api/applyCheck/queryOtherFileOutRecordList', params)
  },
  async queryFileOutApplyCheckList(_context: { commit: Commit }, params: any) {
    return api.post('/api/applyCheck/listApply', params)
  },
  async submitFileOutApplyCheck(_context: { commit: Commit }, params: any) {
    return api.post('/api/applyCheck/newApply', params)
  },
  async deleteFileOutApplyCheck(_context: { commit: Commit }, params: any) {
    return api.post('/api/applyCheck/deleteApplyCheck', params)
  },
  async query_mis_id_list(_context: { commit: Commit }, params: any) {
    return api.post('/api/strategy/query_mis_id_list', params)
  },
  async query_org_list(_context: { commit: Commit }, params: any) {
    return api.post('/api/strategy/query_org_list', params)
  },
  async query_org_info_list(_context: { commit: Commit }, params: any) {
    return api.post('/api/strategy/query_org_info_list', params)
  },
  async querySuperiorSetting(_context: { commit: Commit }, params: any) {
    return api.post('/api/applyCheck/selectSuperiorSetting', params)
  },
  async submitSuperiorSetting(_context: { commit: Commit }, params: any) {
    return api.post('/api/applyCheck/saveSuperiorSetting', params)
  },
  async submitRecordSuperiorFeedback(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileOutgoing/save_superior_feedback', params)
  },
  async terminateFileOutByOthers(_context: { commit: Commit }, params: any) {
    return api.post('/api/fileOutRecord/terminate_file_out_by_others', params);
  }
};

export default {
  actions
}
